import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'


export default function WaterQuantityPreventiveWorkPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, handleIsPost, apiFlag, rowData } = props

    // const [rowData, setRowData] = useState(Flag === 'Update' ? rowData : '')
    const [IsOpen, setIsOpen] = useState(false)


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [LocationName, setLocationName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [PipeSize, setPipeSize] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [IncomingYesterdayReading, setIncomingYesterdayReading] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [OutgoingYesterdayReading, setOutgoingYesterdayReading] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quantity</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date :</b></label>
                                        <input type="date" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Prabhag No :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='wardName'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location Name :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='locationName'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pipe Size :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        {/* <label for=""><b>Incoming Yesterday Reading :</b></label>
                                        <Select
                                            // isClearable
                                            // isRtl={isRtl}
                                            // className="ddl_width"
                                            isSearchable
                                            maxMenuHeight={150}
                                            value={{ value: IncomingYesterdayReading.ID, label: IncomingYesterdayReading.Label }}
                                            onChange={(e) => {
                                                e ?
                                                    setIncomingYesterdayReading({ ...IncomingYesterdayReading, ID: e.value, Label: e.label })
                                                    :
                                                    setIncomingYesterdayReading({ ...IncomingYesterdayReading, ID: 0, Label: "Select..." })

                                            }}
                                            options={IncomingYesterdayReading.DDL}
                                        /> */}
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Incoming Yesterday Reading :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />

                                    </div>

                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Today's Reading :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        {/* <label for=""><b>Outgoing Yesterday Reading :</b></label>
                                        <Select
                                            // isClearable
                                            // isRtl={isRtl}
                                            // className="ddl_width"
                                            isSearchable
                                            maxMenuHeight={150}
                                            value={{ value: OutgoingYesterdayReading.ID, label: OutgoingYesterdayReading.Label }}
                                            onChange={(e) => {
                                                e ?
                                                    setOutgoingYesterdayReading({ ...OutgoingYesterdayReading, ID: e.value, Label: e.label })
                                                    :
                                                    setOutgoingYesterdayReading({ ...OutgoingYesterdayReading, ID: 0, Label: "Select..." })

                                            }}
                                            options={OutgoingYesterdayReading.DDL}
                                        /> */}
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Incoming Yesterday Reading :</b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='pipeSize'
                                            aria-describedby="emailHelp"
                                        // value={PumpingStationTextField.pumpSetDetails}
                                        // onChange={(e) => handlePumpingStationTextField(e)}
                                        />

                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Today's Reading :</b></label>
                                        <input type="text" className="form-control"
                                            id=""
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}